import type { ReactNode } from 'react';

interface OrgModulePlaceholderProps {
  intent: string;
  children?: ReactNode;
}

/**
 * Temporary placeholder to keep routes wired while the underlying module is
 * being implemented. Each module will replace this with real surfaces during
 * the enhancement pass tracked in this change.
 */
const OrgModulePlaceholder = ({ intent, children }: OrgModulePlaceholderProps) => {
  return (
    <div className="org-module__placeholder">
      <p>{intent}</p>
      {children}
    </div>
  );
};

export default OrgModulePlaceholder;
